// extracted by mini-css-extract-plugin
export default {"delivery-address":"OhCustomerInfo_delivery-address__Uxa0c","title":"OhCustomerInfo_title__uSTq9","phone-number":"OhCustomerInfo_phone-number__APmp8"};